/**
 * @ngdoc service
 * @name buildium.appBase.RedirectToLogin
 *
 * @description
 *
 * Change the window's location to the appropriate URL for the login page
 */

export function RedirectToLoginService(
    $window,
    BASE_PATH_PUBLIC,
    IS_LOCALHOST,
    PUBLIC_HYBRID_LOCALHOST,
    HYBRID_LOCALHOST,
    BASE_PATH_APP
) {
    const service = {};

    service.redirect = function redirect() {
        let loginUrl = `${BASE_PATH_PUBLIC}/authentication/login`;

        if (IS_LOCALHOST) {
            loginUrl = `https://${PUBLIC_HYBRID_LOCALHOST}${BASE_PATH_PUBLIC}/authentication/login`;
        }
        $window.location.assign(loginUrl);
    };

    service.redirectAndForceLogout = function redirect() {
        const baseUrl = IS_LOCALHOST ? `https://${HYBRID_LOCALHOST}` : `${$window.location.origin}${BASE_PATH_APP}`;
        const loginUrl = `${baseUrl}?force-logout=true`;
        $window.location.assign(loginUrl);
    };

    return service;
}
RedirectToLoginService.$inject = [
    '$window',
    'BASE_PATH_PUBLIC',
    'IS_LOCALHOST',
    'PUBLIC_HYBRID_LOCALHOST',
    'HYBRID_LOCALHOST',
    'BASE_PATH_APP'
];
